export const GET_USER_INFO = 'GET_USER_INFO'
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO'

export const FETCH_USER_INFO_REQUEST = 'FETCH_USER_INFO_REQUEST'
export const FETCH_USER_INFO_SUCCESS = 'FETCH_USER_INFO_SUCCESS'
export const FETCH_USER_INFO_FAILURE = 'FETCH_USER_INFO_FAILURE'
export const FETCH_USER_INFO_CLEANUP = 'FETCH_USER_INFO_CLEANUP'
